















































//@ts-nocheck
import { Component, Vue } from 'vue-property-decorator';
import HelloWorld from '@/components/HelloWorld.vue'; // @ is an alias to /src
 import VueRecaptcha from 'vue-recaptcha';
@Component({
  components: {
    HelloWorld,
   VueRecaptcha
     
  },
   data:() => ({
     elemento:null as any,
     robot: false,
      usuario:"" as any,
      contrasena:"" as any
    }),
  methods:{ 

   async  onVerify(response) {
     console.log(response,'---------------------')
      if (response) this.robot = true;
    },
  
       async login(){
//const loading = this.$vs.loading({type:'square',
 //  text: 'cargando...'})
 await this.$store
        .dispatch("LOGIN", {
          usuario:this.usuario,   
          contrasena:this.contrasena
        })
        .then(response => {
              console.log(response)
              
          
             if (this.robot){
              if(response==null){

              }}else{

                console.log(response,'///////response');
if(response.hasOwnProperty("message")){

 this.$root.$emit("alerta_show", "Las Credenciales ingresadas no son validas");

  return;
}

                   this.$store.state.user=response;
                   console.log(this.$store.state.user)
              this.$store.commit('SETUSER',this.$store.state.user);
              
                  if(this.$store.state.user.usuario.role=='admin'){
                      
  this.$router.push('/su')
                  }else if(this.$store.state.user.usuario.role=='municipios'){
  this.$router.push('/mun/general/dash')
                  }
              }
//loading.close();
                  
                });

     
   }
  }

  
})
export default class Home extends Vue {}
